import { render, staticRenderFns } from "./m-block-support-message.vue?vue&type=template&id=25c418fa&scoped=true&lang=pug&"
import script from "./m-block-support-message.vue?vue&type=script&lang=js&"
export * from "./m-block-support-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c418fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
